import asyncFetch from './async-fetch';
import { getBaseRequestConfig } from './baseRequestConfig';

export async function fetchDropboxes() {
    /* global API_BASE_URL */
    const url = `${API_BASE_URL}/dropboxes`;

    const baseRequestConfig = getBaseRequestConfig();

    const response = await asyncFetch(url, baseRequestConfig);

    return await response.json();
}

export async function updateDropbox(dropbox){
    /* global API_BASE_URL */
    const url = `${API_BASE_URL}/dropboxes/${dropbox.id}`;

    let baseRequestConfig = getBaseRequestConfig();
    baseRequestConfig.method = "PUT";
    baseRequestConfig.body = JSON.stringify(dropbox);
    baseRequestConfig.headers['content-type'] = 'application/json';

    const response = await asyncFetch(url, baseRequestConfig);

    return await response.json();
}



/** WEBPACK FOOTER **
 ** ./src/connectivity/api.dropboxes.js
 **/